import { ZinantisRelationshipStatusTypeKeys } from '../../../types/zinantis/members/membersType';

//sección que han creado en prod para meter sus agencias de "test"
export const FILTERED_ACCOUNT_MANAGEMENT_SEGMENT_KEY = 'INTERNAL_ONLY';
export const CANCELLED_AS_DISCONNECTED_STATUS_KEY = 'CANCELLED';
export const REJECTED_AS_DISCONNECTED_STATUS_KEY = 'REJECTED';
export const PENDING_MEMBER_STATUS_KEY = 'PENDING';

export const memberDisconnectedStatusColor = '#D0D0D0';

export const connectedMembersOrder: Partial<
    Record<ZinantisRelationshipStatusTypeKeys, number>
> = {
    [ZinantisRelationshipStatusTypeKeys.CONFIRMED]: 1,
    [ZinantisRelationshipStatusTypeKeys.PENDING]: 2,
    [ZinantisRelationshipStatusTypeKeys.REJECTED]: 3,
};

export const typeaheadFilterInputStyles = {
    padding: '0 10px',
    border: '1px solid var(--border)',
    borderRadius: '5px',
    backgroundColor: 'var(--white)',

    '& input::placeholder': {
        textTransform: 'capitalize',
    },
    '& .MuiInput-underline:before': {
        borderBottom: 'none',
    },
    '& .MuiInput-underline:after': {
        borderBottom: 'none',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
        borderBottom: 'none',
    },
};

export const PENDING_ZINANTIS_RELATIONSHIP_STATUS_TYPE_INITIAL_STATE = {
    key: ZinantisRelationshipStatusTypeKeys.PENDING,
    text: 'Pending',
    color: '#FFA500',
};
